import { render, staticRenderFns } from "./MultipleDeleteDialog.vue?vue&type=template&id=5e629778&"
import script from "./MultipleDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./MultipleDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports